import { Card, Text, Title, Table, TableHead, TableHeaderCell, TableBody, TableRow, TableCell } from '@tremor/react';
import { formatInt, formatMxn } from '../lib/format';
import { t } from '../lib/i18n';
import type { TopCustomer } from '../api/types';
import DrillCell from './DrillCell';

interface Props { rows: TopCustomer[]; }

export default function TopCustomersTable({ rows }: Props) {
  return (
    <Card>
      <Title>{t.tables.topCustomersTitle}</Title>
      {rows.length === 0 ? (
        <Text className="mt-4">{t.tables.empty}</Text>
      ) : (
        <Table className="mt-4">
          <TableHead>
            <TableRow>
              <TableHeaderCell className="w-8 text-right">#</TableHeaderCell>
              <TableHeaderCell>{t.tables.cols.account}</TableHeaderCell>
              <TableHeaderCell>{t.tables.cols.name}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.tables.cols.ticketCount}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.tables.cols.revenue}</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={r.anum}>
                <TableCell className="text-right text-tremor-content text-xs tabular-nums">{i + 1}</TableCell>
                <TableCell className="font-mono text-xs">
                  {/* TopCustomer.anum is a string on this payload; a row that
                      isn't a positive account number renders as plain text. */}
                  <DrillCell
                    target={Number(r.anum) > 0 ? { kind: 'account', anum: Number(r.anum) } : null}
                  >
                    {r.anum}
                  </DrillCell>
                </TableCell>
                <TableCell>{r.name}</TableCell>
                <TableCell className="text-right tabular-nums">{formatInt(r.ticket_count)}</TableCell>
                <TableCell className="text-right tabular-nums">{formatMxn(r.revenue_mxn)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
}
